export default __webpack_public_path__ + "static/media/all_bonuses.35794275.svg";